import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import clsx from "clsx";

import withShowModal from "../../hocs/with_show_modal.js";
import { compose } from 'redux';

import I18n from "../../base/i18n.js";

import HtmlContent from "../../base/components/html_content.js";

import MoneyFormatter from "../../utils/money_formatter.js";

import ParticipantsInvestmentInfo from "./participants_investment_info.js";

const blockStyles = makeStyles(theme => ({
  root: {

  },
  multipleRow: {

  },
  text: {
    fontSize: "16px",
    lineHeight: "22px",
    fontWeight: theme.typography.fontWeightMedium,
    ['@media (max-width: 768px)']: {
      fontSize: "13px",
      lineHeight: "16px",
    },
  },
  label: {
    color: theme.palette.grayText,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "auto"
  },
  buttonText: {
    display: "block",
    marginRight: "5px",
  },
  icon: {
    width: "17px",
    height: "17px"
  }
}));

/**
 * Display info about investment of user
 * @name ParticipantInfo
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @param {object.<string, string>} [props.classes] CSS-classes for inner elements. Accept keys:
 *    - tooltip
 *    - info
 *    - investmentStatus
 *    - date
 *    - amountRow
 *    - myInvestment
 *    - interest
 *    - multipleRow
 *    - text
 *    - showMore
 * @param {object} [props.participant] Info about participant from API
 * @param {object} [props.project] Info about project from API
 * @example
 * return (
 *  <ParticipantInfo participant = { participant }
 *                   project = { project }
 *                   className = { "class-name" }
 *                   classes = { {
 *                     info: "info",
 *                     date: "date",
 *                     myInvestment: "my-investment"
 *                   } }  />
 * )
*/

const ParticipantInfo = (props) => {
  const { participant, className, classes : externalClasses = {} } = props;

  if(!participant) {
    return <React.Fragment />
  }

  const { investments = [] } = participant;

  if(investments.length === 0) {
    return <React.Fragment />
  }

  const totalInvestmentsAmount = investments.map((investment) => parseFloat(investment.amount))
                                            .reduce((total, amount) => total + amount)

  const classes = blockStyles();

  return (
    <div className = { clsx(classes.root, className) } >
      {
        investments.length === 1 &&
        <ParticipantsInvestmentInfo investment = { investments[0] }
                                    classes = { externalClasses } />
      }
      {
        investments.length > 1 &&
        <div className = { clsx(classes.multipleRow, externalClasses.multipleRow) } >
          <HtmlContent className = { clsx(classes.text, externalClasses.text) } >
            {
            I18n.t("component.participant_info.text", {
              count: investments.length,
              amount: `${MoneyFormatter.format(totalInvestmentsAmount)} ${I18n.t("currency.euro")}`
            })
            }
          </HtmlContent>
        </div>
      }
    </div>
  )
}

ParticipantInfo.propTypes = {
  classes: PropTypes.shape({
    tooltip: PropTypes.string,
    info: PropTypes.string,
    investmentStatus: PropTypes.string,
    date: PropTypes.string,
    amountRow: PropTypes.string,
    myInvestment: PropTypes.string,
    interest: PropTypes.string,
    text: PropTypes.string
  })
}
export default compose(withShowModal)(ParticipantInfo);
